export default __webpack_public_path__ + "static/media/short_logo.837f5d97.svg";